import {
  APIConnectionConfig,
  ModuleConfig,
  ModuleDisplayConfig,
  ModuleMapConfig,
} from '@schamburg-web/interfaces';
import { eventImpactSort } from '../utils';
import IncidentDisplayCard from './IncidentDisplayCard';
import IncidentMarker from './IncidentMarker';

export const incidentIcon = '/mapicons/incident.svg';
export const signalFlashIcon = '/mapicons/signal-flash.svg';
export const signalOutIcon = '/mapicons/signal-out.svg';

const mapModuleConfig: ModuleMapConfig = {
  zIndex: 100,
  layerIcon: incidentIcon,
  showOnMap: true,
  defaultEnabled: true,
  wmsMapLayer: {
    server: import.meta.env.VITE_REACT_APP_GEOSERVERURL + '/wms?',
    args: {
      LAYERS: ['lake:specialeventoverlays', 'lake:othereventoverlays'],
      STYLES: [],
      SRS: 'EPSG:900913',
    },
  },
};

const displayConfig: ModuleDisplayConfig = {
  label: 'Incident',
  isPopupDialog: false,
  isMobilePopupDialog: true,
  popupDef: IncidentDisplayCard,
  cardDef: IncidentDisplayCard,
  isOnSideBar: true,
  markerDef: IncidentMarker,
  avatarDef: incidentIcon,
  sidebarSort: eventImpactSort,
  panTo: true,
  showMarquee: true, // Enable marquee for incidents
};

const apiConfig: APIConnectionConfig = {
  endpoint: 'incidents',
  updateDelay: 0,
  publishLayer: 'incidents',
};

const moduleConfig: ModuleConfig = {
  moduleLabel: 'Incidents',
  name: 'incident',
  mapConfig: mapModuleConfig,
  displayConfig: displayConfig,
  apiConfig: apiConfig,
};

export default moduleConfig;
